export default __webpack_public_path__ + "static/media/72459471498662388229082474994677492985349853758174844842761352625564680207.gif.89dc61dd.mp4";